// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-46f4480f]{border-radius:0;color:var(--light-color)}.dropdown-toggle[data-v-46f4480f]{padding:0}.dropdown-toggle[data-v-46f4480f]:after{display:none}", ""]);
// Exports
module.exports = exports;
